import { SelectOption } from "@veneer/core";

interface IOptions {
  Country: SelectOption[];
  State: SelectOption[];
  City: SelectOption[];
  Role: SelectOption[];
  Time: SelectOption[];
  Partner: SelectOption[];
  Fund: SelectOption[];
  FundHP: SelectOption[];
  Supervisor: SelectOption[];
  Coordinator: SelectOption[];
  Categories:  SelectOption[];
  FilteredCountry: SelectOption[];
  FilteredState: SelectOption[];
  FilteredCity: SelectOption[];
  FilteredRole: SelectOption[];
  FilteredTime: SelectOption[];
  FilteredPartner: SelectOption[];
  FilteredFund: SelectOption[];
  FilteredFundHP: SelectOption[];
  FilteredSupervisor: SelectOption[];
  FilteredCoordinator: SelectOption[];
  FilteredCategories: SelectOption[];
}

const useSearchSelect = () => {
    async function handleSearch(
      value: string,
      key: keyof IOptions,
      optionsCopy: SelectOption[],
      setOptions: (options: React.SetStateAction<IOptions>) => void
    ) {
      try {
        const lowerCaseQuery = value.toLocaleLowerCase();
  
        const filteredOptions = optionsCopy.filter((objeto) =>
          objeto.label?.toLocaleLowerCase().includes(lowerCaseQuery)
        );

        setOptions((prevState) => ({
          ...prevState,
          [key]: filteredOptions,
        }));
      } catch (error) {
        console.error("Error during search: ", error);
      }
    }
    return {
      handleSearch,
    };
};
  
export default useSearchSelect;